import React from 'react';

import { useRouter } from 'next/router';

import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { queryClientConfig } from '@core/configs/queryClientConfig';
import { NextSeo } from 'next-seo';
import { getSubscriptionPlans } from 'services/payments';
import { setSsrTokens } from 'utils/authentication';
import Spinner from '@core/components/spinner/Spinner';

import PlansWrapper from 'components/pages/plans/PlansWrapper';

const index = () => {
    const seoProps = generateSeoProps({
        title: 'Pharmuni Subscription Plans: Elevate Your Pharmaceutical Career',
        description: 'Choose Pharmuni Premium for unlimited access to pharma courses, certifications, and career tools. Invest in your future with our annual or monthly plans.',
        canonical: 'plans',
        noIndex: false
    });
    const router = useRouter();

    const { data, isLoading, error } = useQuery(['get-subscription-plans'], getSubscriptionPlans, {       
        onError: (e) => {
            if (e.response.status === 404) {
                router.replace('/404');
            }
        }
    });

    return (
        <>
            <NextSeo {...seoProps} />
            {data && !isLoading ? (
                <PlansWrapper data={data.data} />
            ) : (
                <div className="w-100 my-5 py-5 d-flex align-items-center justify-content-center">
                    <Spinner />
                </div>
            )}
        </>

    );

};

export async function getServerSideProps(context) {
    setSsrTokens(context);
    const queryClient = new QueryClient(queryClientConfig);
    const { req } = context;
    const userIp = req.headers['x-forwarded-for'];
    try {
        const response = await getSubscriptionPlans(userIp);
        await queryClient.prefetchQuery(['get-subscription-plans'], () => ({ data: response.data }));
    } catch (e) {
        if (e.response.status === 435)
            return {
                redirect: {
                    permanent: false,
                    destination: "/user-dashboard"
                }
            }
        else
            return {}
    }
    return {
        props: {
            dehydratedState: dehydrate(queryClient)
        }
    };
}

export default index;